import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLinkBox12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconLinkBox12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.5 2h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5m-9-1A1.5 1.5 0 0 0 0 2.5v7A1.5 1.5 0 0 0 1.5 11h9A1.5 1.5 0 0 0 12 9.5v-7A1.5 1.5 0 0 0 10.5 1zm3 2.5a2.5 2.5 0 0 0 0 5H5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 1 1 0-3H5a.5.5 0 0 0 0-1zm.25 2a.5.5 0 0 0 0 1h2.5a.5.5 0 0 0 0-1zm2.75 3a2.5 2.5 0 0 0 0-5H7a.5.5 0 0 0 0 1h.5a1.5 1.5 0 1 1 0 3H7a.5.5 0 0 0 0 1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLinkBox12);
